import {HexagonText, Table} from 'web-components';
import {
	totalsActual,
	totalsDifference,
	totalsEstimate,
	totalsForecastRevenue,
	totalsLockedRevenue,
	totalsPlanned,
	totalsProjected,
	totalsRecognitionForecastRevenue,
	totalsrecognitionOpenRevenue,
	totalsRecognitionSurplus,
	totalsRemaining,
	totalsRemainingRevenue,
	totalsReported,
} from '../renders/TaskTotalsHeaders';
import React from 'react';
import {ESTIMATION_UNIT, profilePicSrc} from '../../../../constants';

const GroupColumns = (row, intl, currency) => {
	return [
		<Table.Column>
			{row && row.isPerson ? (
				<HexagonText
					intl={intl}
					active={row.active}
					text={row.fullName}
					imgUrl={row.profilePictureId ? profilePicSrc(row.profilePictureId) : null}
				/>
			) : (
				<span>{row && (row.generatedName || row.name)}</span>
			)}
		</Table.Column>,
		<Table.Column />,
		<Table.Column />,
		<Table.Column />,
		<Table.Column />,
		<Table.Column />,
		<Table.Column />,
		<Table.Column />,
		<Table.Column />,
		<Table.Column />,
		<Table.Column />,
		<Table.Column />,
		<Table.Column />,
		<Table.Column />,
		<Table.Column />,
		<Table.Column />,
		<Table.Column />,
		<Table.Column />,
		<Table.Column />,
		<Table.Column>{row.taskTotals && totalsEstimate(row.taskTotals, intl, ESTIMATION_UNIT.HOURS)}</Table.Column>,
		<Table.Column>{row.taskTotals && totalsEstimate(row.taskTotals, intl, ESTIMATION_UNIT.POINTS)}</Table.Column>,
		<Table.Column>{row.taskTotals && totalsProjected(row.taskTotals, intl)}</Table.Column>,
		<Table.Column>{row.taskTotals && totalsReported(row.taskTotals, intl)}</Table.Column>,
		<Table.Column>{row.taskTotals && totalsRemaining(row.taskTotals, intl, ESTIMATION_UNIT.HOURS)}</Table.Column>,
		<Table.Column>{row.taskTotals && totalsRemaining(row.taskTotals, intl, ESTIMATION_UNIT.POINTS)}</Table.Column>,
		<Table.Column>{row.taskTotals && totalsDifference(row.taskTotals, intl, ESTIMATION_UNIT.HOURS)}</Table.Column>,
		<Table.Column>{row.taskTotals && totalsDifference(row.taskTotals, intl, ESTIMATION_UNIT.POINTS)}</Table.Column>,
		<Table.Column negative={row.taskTotals?.plannedRevenue && row.taskTotals.plannedRevenue < 0}>
			{row.taskTotals && totalsPlanned(row.taskTotals, currency, intl)}
		</Table.Column>,
		<Table.Column negative={row.taskTotals?.actualRevenue && row.taskTotals.actualRevenue < 0}>
			{row.taskTotals && totalsActual(row.taskTotals, currency, intl)}
		</Table.Column>,
		<Table.Column negative={row.taskTotals?.remainingRevenue && row.taskTotals.remainingRevenue < 0}>
			{row.taskTotals && totalsRemainingRevenue(row.taskTotals, currency, intl)}
		</Table.Column>,
		<Table.Column negative={row.taskTotals?.forecastRevenue && row.taskTotals.forecastRevenue < 0}>
			{row.taskTotals && totalsForecastRevenue(row.taskTotals, currency, intl)}
		</Table.Column>,
		<Table.Column negative={row.taskTotals?.lockedRevenue && row.taskTotals.lockedRevenue < 0}>
			{row.taskTotals && totalsLockedRevenue(row.taskTotals, currency, intl)}
		</Table.Column>,
		<Table.Column negative={row.taskTotals?.recognitionOpenRevenue && row.taskTotals.recognitionOpenRevenue < 0}>
			{row.taskTotals && totalsrecognitionOpenRevenue(row.taskTotals, currency, intl)}
		</Table.Column>,
		<Table.Column negative={row.taskTotals?.recognitionForecastRevenue && row.taskTotals.recognitionForecastRevenue < 0}>
			{row.taskTotals && totalsRecognitionForecastRevenue(row.taskTotals, currency, intl)}
		</Table.Column>,
		<Table.Column negative={row.taskTotals?.surplus && row.taskTotals.surplus < 0}>
			{row.taskTotals && totalsRecognitionSurplus(row.taskTotals, currency, intl)}
		</Table.Column>,
		<Table.Column />,
		<Table.Column />,
	];
};

export default GroupColumns;
